import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from 'antd';

class ModalFooter extends React.PureComponent {
    render() {
        const { container_class, hide_cancel_button, hide_ok_button, capsule_button, loading, btn_style, btn_class, ok_btn_type, cancel_btn_type, ok_btn_class, cancel_btn_class, button_ok_text, size, button_cancel_text, button_ok_type, button_ok_disabled, handleOkClick, handleCancelClick } = this.props;
        return (
            <div className={container_class}>
                {
                    !hide_cancel_button &&
                    <Button
                        size={size}
                        type={cancel_btn_type}
                        className={classNames(`${cancel_btn_class} ${btn_class}`, {
                            "ori-border-radius-20": capsule_button
                        })}
                        style={btn_style}
                        onClick={handleCancelClick}
                    >
                        {button_cancel_text}
                    </Button>
                }
                {
                    !hide_ok_button &&
                    <Button
                        size={size}
                        type={ok_btn_type}
                        htmlType={button_ok_type}
                        loading={loading}
                        className={classNames(`${ok_btn_class} ${btn_class}`, {
                            "ori-border-radius-20": capsule_button
                        })}
                        style={btn_style}
                        disabled={button_ok_disabled}
                        onClick={handleOkClick}
                    >
                        {button_ok_text}
                    </Button>
                }
            </div>
        );
    }
}

ModalFooter.propTypes = {
    container_class: PropTypes.string,
    capsule_button: PropTypes.bool,
    hide_cancel_button: PropTypes.bool,
    hide_ok_button: PropTypes.bool,
    loading: PropTypes.bool,
    btn_style: PropTypes.object,
    btn_class: PropTypes.string,
    size: PropTypes.oneOf(['large', 'small', 'default']),
    cancel_btn_class: PropTypes.string,
    ok_btn_class: PropTypes.string,
    ok_btn_type: PropTypes.string,
    cancel_btn_type: PropTypes.string,
    button_ok_disabled: PropTypes.bool,
    button_cancel_text: PropTypes.string,
    handleCancelClick: PropTypes.func,
    button_ok_text: PropTypes.string,
    button_ok_type: PropTypes.string,
    handleOkClick: PropTypes.func,
};

ModalFooter.defaultProps = {
    container_class: "ori-pad-10 ori-flex-row ori-flex-jc",
    hide_cancel_button: false,
    capsule_button: false,
    loading: false,
    button_ok_text: "ok",
    button_cancel_text: "cancel",
    size: "default",
    ok_btn_type: "primary",
    ok_btn_class: "ori-lr-mrgn-5 ori-capitalize",
    cancel_btn_class: "ori-lr-mrgn-5 ori-capitalize",
};

export default ModalFooter;


// WEBPACK FOOTER //
// ./src/components/modalfooter/index.js